export enum RoleEnum {
  roleFormalist = 'ROLE_FORMALIST',
  roleNotary = 'ROLE_NOTARY'
}
